export default {
  section_title: 'Valuta',
  label: 'Valuta',
  tooltip:
    'De valuta die uw prijzen, uitbetalingen en rapporten gebruiken. Deze is ingesteld voor uw partneraccount bij het aanmaken en kan hier niet worden gewijzigd — neem contact op met support als dit onjuist is.',
  from_your_partner: 'Van uw partner',
  set_for_your_account: 'Ingesteld voor uw account',
};
